module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "expandable"
  }, [_c('div', {
    staticClass: "label",
    on: {
      "click": function($event) {
        _vm.expanded = !_vm.expanded;
      }
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    key: _vm.expanded
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.expanded ? 'fa-chevron-down' : 'fa-chevron-up'
  })])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.expanded) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-71e4ee16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/components/expandable.vue
// module id = 3264
// module chunks = 0